var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100"},[(_vm.isLoading)?_c('loader'):_c('form-builder',{ref:"formBuilder",attrs:{"upload":"","preview":"","generate-json":"","data":_vm.record,"clearable":""}},[_c('template',{slot:"action"})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }